module.exports = __webpack_public_path__ + "static/media/check-box.bcf5953e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/check-box.svg
// module id = 882
// module chunks = 21